import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { getAnalyticsData, getApplications, getDevices, getSensors } from "../models/data-visuals";

@Injectable({
    providedIn: 'root'
})

export class DataVisualsService{
    constructor (
        private http: HttpClient
    ) {}

    getAllAnalyticsData(payload : getAnalyticsData, api_key : any, client_id : any){
        const url = `${environment.apiURL}/admin/grok/get-sensor-data`;
        return this.http.post<getAnalyticsData>(url, payload, {
            headers : {client_id : client_id, api_key : api_key}
        })
    }

    getOrganizations(){
        const url = `${environment.apiURL}/admin/grok/get-organizations`;
        return this.http.get<any>(url)
    }

    getDevices(payload : getDevices){
        const url = `${environment.apiURL}/admin/grok/get-devices`;
        return this.http.post<getDevices>(url, payload)
    }

    getApplications(payload : getApplications){
        const url = `${environment.apiURL}/admin/grok/get-applications`;
        return this.http.post<getApplications>(url, payload)
    }

    getSensors(payload : getSensors){
        const url = `${environment.apiURL}/admin/grok/get-sensors`;
        return this.http.post<getSensors>(url, payload)
    }

    getOrganizationDetails(organizationId : string){
        const url = `${environment.apiURL}/admin/grok/get-organization-details`;
        const params = { organizationId }
        return this.http.get<any>(url, {params})
    }

}